import { Menu, MenuProps, Tooltip } from 'antd';
import {
  FaAddressBook,
  FaAddressCard,
  FaChartBar,
  FaChartPie,
  FaCoins,
  FaSimplybuilt,
  FaUserFriends,
} from 'react-icons/fa';
import { FiBarChart2, FiLogOut } from 'react-icons/fi';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  ConnectedUserEntity,
  ProfilType,
} from '../../../../entities/ConnectedUserEntity';
import { ROUTES } from '../../../../routes';

type MenuItem = Required<MenuProps>['items'][number];

export const SideBar = ({
  defaultOpenKeys,
  current,
}: {
  defaultOpenKeys: string[];
  current?: string;
}) => {
  const history = useHistory();
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  // const onClick: MenuProps['onClick'] = (e) => {
  //   console.log('click ', e);
  // };

  const hasAccess = (authorization: ProfilType[]) => {
    for (let profil of authorization) {
      if (
        connectedUser.profils.map((pro) => pro.code_profil).includes(profil)
      ) {
        return true;
      }
    }
    return false;
  };

  function getItem(
    label: React.ReactNode,
    key?: React.Key | null,
    link?: string | null,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: 'group',
    authorization?: ProfilType[],
  ): MenuItem {
    if (authorization?.length === 0 || authorization !== undefined) {
      if (hasAccess(authorization)) {
        return {
          key,
          icon,
          children,
          label,
          type,
          onClick: () => {
            link && history.push(link);
          },
        } as MenuItem;
      } else {
        return undefined as any;
      }
    } else {
      return {
        key,
        icon,
        children,
        label,
        type,
        onClick: () => {
          link && history.push(link);
        },
      } as MenuItem;
    }
  }

  const MenuItems: MenuItem[] = [
    getItem(
      'Administration MoranjEtrade',
      'm11',
      undefined,
      <FaAddressCard />,
      [
        getItem(
          'Gestion des clients MoranjEtrade',
          '11.1',
          ROUTES.ADMIN.CONSOLE,
        ),
        getItem('Gestion des Packs', '11.2', ROUTES.ADMIN.PACK),
        getItem('Gestion des Parametres', '11.3', ROUTES.ADMIN.PARAMETER),
        getItem('Reporting', '11.4', ROUTES.ADMIN.REPORTING),
      ],
      undefined,
      ['sadmin'],
    ),
    getItem(
      'Administration',
      'm1',
      undefined,
      <FaAddressBook />,
      [
        getItem(
          'Gestion des partenaires',
          '1.1',
          ROUTES.PANEL.ADMIN.PARTENAIRE,
        ),
        getItem(
          'Gestion des utilisateurs/profils',
          '1.2',
          ROUTES.PANEL.ADMIN.GESTION_USERS_PROFIL,
        ),
        getItem(
          'Gestion des mots de passe',
          '1.3',
          ROUTES.PANEL.ADMIN.GESTION_PASSWORD,
        ),
        // getItem('Horizons de placement', '1.4'),
      ],
      undefined,
      ['admin'],
    ),
    getItem(
      'Gestion de la clientèle',
      'm12',
      ROUTES.PANEL.CLIENTELE.CLIENTS,
      <FaUserFriends />,
      undefined,
      undefined,
      ['resp_commercial', 'commercial', 'chef_agence', 'gestionnaire'],
    ),
    getItem(
      'Gestion de titre',
      'm7',
      ROUTES.PANEL.EMISSION.TITRE,
      <FaCoins />,
      undefined,
      undefined,
      ['resp_commercial', 'responsable'],
    ),
    getItem(
      'Comptabilité',
      'm2',
      undefined,
      <FiBarChart2 />,
      [
        getItem('Comptes', 'm2.1', ROUTES.PANEL.COMPTABILITE.COMPTE),
        getItem(
          <Tooltip title='Grand Livre & Balance Générale' placement='rightTop'>
            Grand Livre & Balance Générale
          </Tooltip>,
          'm2.2',
          ROUTES.PANEL.COMPTABILITE.GRAND_LIVRE,
        ),
      ],
      undefined,
      ['resp_commercial', 'responsable'],
    ),
    getItem(
      'Reporting Portefeuille',
      'm9',
      ROUTES.REPORTING.PORTEFEUILLE,
      <FaChartPie />,
      undefined,
      undefined,
      ['resp_commercial', 'commercial', 'chef_agence', 'gestionnaire'],
    ),
    getItem(
      'Reporting',
      'm3',
      ROUTES.REPORTING.TITRE,
      <FaChartBar />,
      undefined,
      undefined,
      ['resp_commercial', 'commercial', 'chef_agence', 'gestionnaire'],
    ),
    getItem(
      'Module de simulation',
      'm4',
      null,
      <FaSimplybuilt />,
      undefined,
      undefined,
      ['resp_commercial', 'commercial', 'chef_agence', 'gestionnaire'],
    ),
    getItem(
      'eTrading',
      'm5',
      ROUTES.DASHBOARD.PAGE,
      <FaChartBar />,
      undefined,
      undefined,
      ['resp_commercial', 'commercial', 'chef_agence', 'gestionnaire'],
    ),
    getItem('Deconnexion', 'm6', null, <FiLogOut />),
  ];

  return (
    <Menu
      theme='dark'
      // onClick={onClick}
      style={{ width: 256 }}
      defaultOpenKeys={defaultOpenKeys}
      selectedKeys={current ? [current] : defaultOpenKeys}
      mode='inline'
      items={MenuItems}
    />
  );
};
